import { gql } from '../../__generated__/gql'

export const APPLY_LAB_PLUS_BENEFIT_MUTATION = gql(`
  mutation applyLabPlusBenefit {
    applyLabPlusBenefit(input: {}) {
      clientMutationId
    }
  }
`)
